import { render, staticRenderFns } from "./ProfessionalPracticeTermsCreate.vue?vue&type=template&id=e0f3f488"
import script from "./ProfessionalPracticeTermsCreate.vue?vue&type=script&lang=js"
export * from "./ProfessionalPracticeTermsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports